// Generated by purs version 0.13.5
"use strict";
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Array_NonEmpty = require("../Data.Array.NonEmpty/index.js");
var Data_Array_NonEmpty_Internal = require("../Data.Array.NonEmpty.Internal/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Effect = require("../Effect/index.js");
var Indexer_MTime = require("../Indexer.MTime/index.js");
var Node_Path = require("../Node.Path/index.js");
var React_Basic = require("../React.Basic/index.js");
var React_Basic_DOM = require("../React.Basic.DOM/index.js");
var React_Basic_DOM_Events = require("../React.Basic.DOM.Events/index.js");
var React_Basic_DOM_Generated = require("../React.Basic.DOM.Generated/index.js");
var Web_HTML = require("../Web.HTML/index.js");
var Web_HTML_Location = require("../Web.HTML.Location/index.js");
var Web_HTML_Window = require("../Web.HTML.Window/index.js");
var WebApp_Gallery_Clipboard = require("../WebApp.Gallery.Clipboard/index.js");
var images = (function () {
    var isImage = function (name) {
        return Data_Foldable.elem(Data_Foldable.foldableArray)(Data_Eq.eqString)(Node_Path.extname(name))([ ".png", ".jpeg", ".jpg", ".bmp" ]);
    };
    return Data_Array_NonEmpty.filter(function ($21) {
        return isImage((function (v) {
            return v.basename;
        })($21));
    });
})();
var lookupImage = (function () {
    var sortBySize = Data_Array.sortWith(Data_Ord.ordNumber)(function (v) {
        return v.size;
    });
    return function ($22) {
        return Data_Array.last(sortBySize(images($22)));
    };
})();
var modal = (function () {
    var initialState = {
        copyLinkImg: "link"
    };
    var didUpdate = function (self) {
        return function (prev) {
            return Data_Monoid.guard(Data_Monoid.monoidFn(Effect.monoidEffect(Data_Monoid.monoidUnit)))(Data_Eq.notEq(Data_Maybe.eqMaybe(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                return "label";
            }))(Data_Eq.eqString))()(new Data_Symbol.IsSymbol(function () {
                return "files";
            }))(Data_Array_NonEmpty_Internal.eqNonEmptyArray(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                return "size";
            }))(Data_Eq.eqNumber))()(new Data_Symbol.IsSymbol(function () {
                return "mtime";
            }))(Indexer_MTime.eqMTime))()(new Data_Symbol.IsSymbol(function () {
                return "dirname";
            }))(Data_Eq.eqString))()(new Data_Symbol.IsSymbol(function () {
                return "basename";
            }))(Data_Eq.eqString)))))))(self.props.showModal)(prev.prevProps.showModal))(self.setState)(function (v) {
                var $9 = {};
                for (var $10 in v) {
                    if ({}.hasOwnProperty.call(v, $10)) {
                        $9[$10] = v[$10];
                    };
                };
                $9.copyLinkImg = "link";
                return $9;
            });
        };
    };
    var content = function (v) {
        return function (label) {
            return function (v1) {
                if (v1 instanceof Data_Maybe.Nothing) {
                    return React_Basic_DOM_Generated.h1()({
                        style: React_Basic_DOM.css({
                            marginTop: "10%",
                            textAlign: "center",
                            textTransform: "full-width"
                        }),
                        children: [ React_Basic_DOM.text("Image missing") ]
                    });
                };
                if (v1 instanceof Data_Maybe.Just) {
                    var path = Node_Path.concat([ v1.value0.dirname, v1.value0.basename ]);
                    return React_Basic_DOM_Generated.div()({
                        children: [ React_Basic_DOM_Generated.div()({
                            className: "brown",
                            style: React_Basic_DOM.css({
                                textAlign: "center",
                                fontSize: "x-large",
                                marginBottom: "5px",
                                textTransform: "capitalize",
                                color: "white",
                                fontWeight: "800"
                            }),
                            children: [ React_Basic_DOM.text(label), React_Basic_DOM_Generated.a()({
                                className: "right",
                                style: React_Basic_DOM.css({
                                    margin: "6px 10px auto auto",
                                    color: "white"
                                }),
                                href: "#",
                                title: "Copy link to clipboard",
                                onClick: React_Basic_DOM_Events.capture_(function __do() {
                                    var v2 = (function __do() {
                                        var v2 = Control_Bind.bind(Effect.bindEffect)(Web_HTML.window)(Web_HTML_Window.location)();
                                        return Control_Apply.apply(Effect.applyEffect)(Data_Functor.map(Effect.functorEffect)(Data_Semigroup.append(Data_Semigroup.semigroupString))(Web_HTML_Location.origin(v2)))(Web_HTML_Location.pathname(v2))();
                                    })();
                                    Data_Functor["void"](Effect.functorEffect)(WebApp_Gallery_Clipboard.copyToClipboard(v2 + path))();
                                    return v.setState(function (v3) {
                                        return {
                                            copyLinkImg: "done"
                                        };
                                    })();
                                }),
                                children: [ React_Basic_DOM_Generated.i()({
                                    className: "material-icons",
                                    children: [ React_Basic_DOM.text(v.state.copyLinkImg) ]
                                }) ]
                            }) ]
                        }), React_Basic_DOM_Generated.img()({
                            src: path,
                            style: React_Basic_DOM.css({
                                width: "100%",
                                maxWidth: "100%",
                                maxHeight: "100%",
                                backgroundColor: "white"
                            })
                        }) ],
                        style: React_Basic_DOM.css({
                            position: "fixed",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            width: "auto",
                            height: "80%",
                            maxWidth: "100%",
                            maxHeight: "100%"
                        })
                    });
                };
                throw new Error("Failed pattern match at WebApp.Gallery.Modal (line 64, column 5 - line 68, column 75): " + [ v.constructor.name, label.constructor.name, v1.constructor.name ]);
            };
        };
    };
    var render = function (self) {
        var mkModal = function (v) {
            return React_Basic_DOM_Generated.div()({
                style: React_Basic_DOM.css({
                    position: "fixed",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0,0,0,0.4)",
                    zIndex: "1000"
                }),
                onClick: self.props.onClick,
                children: [ content(self)(v.label)(lookupImage(v.files)) ]
            });
        };
        return React_Basic_DOM_Generated.div_([ Data_Maybe.maybe(Data_Monoid.mempty(React_Basic.monoidJSX))(mkModal)(self.props.showModal) ]);
    };
    return React_Basic.make()(React_Basic.createComponent("Modal"))({
        initialState: initialState,
        didUpdate: didUpdate,
        render: render
    });
})();
module.exports = {
    modal: modal,
    lookupImage: lookupImage,
    images: images
};
